const NavigationRoutes = {
  HOME: "/nps",
  SIGNUP: "/signup",
  NEW_SUBSCRIBER_REGISTRATION: "/new-subscriber-registration",
} as const;

export default NavigationRoutes;
